import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {PageMetaComponent} from './page-meta.component';
import {HeaderComponent} from '../../header/header.component';
import {FooterComponent} from '../../footer/footer.component';
import {TheaderComponent} from '../../theader/theader.component';
import {TfooterComponent} from '../../tfooter/tfooter.component';
import { BrowserUtil } from '../../utils/browser.util';

@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [PageMetaComponent, HeaderComponent, FooterComponent, TheaderComponent, TfooterComponent],
    providers:[BrowserUtil],
    exports: [PageMetaComponent, HeaderComponent, FooterComponent, TheaderComponent, TfooterComponent, CommonModule, RouterModule]
})
export class CommonSectionsModule {
}